module.exports = __webpack_public_path__ + "static/media/poll-people.eea1b798.svg";